// extracted by mini-css-extract-plugin
export default {"default":"DefaultTooltip_default__UNa5T"};